import L from 'leaflet';

import { initMap, initLeaflet, map } from './layers-init.js';
import { initWeatherLayer, generateTileLayers, layerLightning } from './layers.js';
import { toggleLayersDefaultLayout } from './layers-toggle.js'
import { checkForNewLayers } from './data-manage.js';
import { baronTiles } from './productMapping.js';
import { popupAlertType } from './popup';

function displayInteractiveMap(defaultLat, defaultLon) {
  initMap()
  initLeaflet(defaultLat, defaultLon)
  initWeatherLayer()
  checkForNewLayers()
  generateTileLayers([baronTiles.radar.composite_250m, baronTiles.alerts.polygon])
  map.on('click', L.bind(popupAlertType, null, 'poly'))
  layerLightning()
  toggleLayersDefaultLayout()
}

export { displayInteractiveMap }